var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperclip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.24675,
    height: 38.00025,
    viewBox: "0 0 33.24675 38.00025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m9.72734,25.8649l2.41,2.409,12.053-12.051c1.99651-1.99706,1.99606-5.23449-.001-7.231-1.99706-1.99651-5.23449-1.99606-7.231.001L2.49534,23.4539c-3.32751,3.32807-3.32707,8.72348.001,12.051,3.32807,3.32752,8.72348,3.32707,12.051-.001l15.186-15.184.033-.031c4.64112-4.64195,4.64045-12.16738-.0015-16.8085-4.64195-4.64112-12.16737-4.64045-16.8085.0015h0l-.03.033h0L2.55834,13.8779l2.412,2.409L15.33634,5.9239c.011-.01.021-.021.031-.031,3.30957-3.31067,8.67633-3.31157,11.987-.002,3.31067,3.30956,3.31157,8.67633.002,11.987l-.033.031h0l-15.186,15.186c-1.99651,1.99706-5.23394,1.99751-7.231.001-1.99706-1.99651-1.99751-5.23394-.001-7.231l14.464-14.462c.66523-.66633,1.74467-.66723,2.411-.002s.66723,1.74467.002,2.411l-12.055,12.053Z",
    fill: "current"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.520985005313833809411ff7ea91a8d5.svg";
export { ForwardRef as ReactComponent };